/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { CustomerFeatureKey } from 'app/core/customer/customer-config.model';

import {
  AQUA_AGGREGATION_FEATURE,
  AQUA_COLD_STORAGE_FEATURE,
  AQUA_DISAGGREGATION_FEATURE,
  AQUA_FEEDING_FEATURE,
  AQUA_FEED_MILL_FEATURE,
  AQUA_HARVEST_FEATURE,
  AQUA_HATCHING_FEATURE,
  AQUA_PROCESSING_FEATURE,
  AQUA_RECEIPT_FEATURE,
  AQUA_SHIPPING_FEATURE,
  AQUA_TRANSFER_FEATURE,
  AUX_CAGE_DETAILS_FEATURE,
  AUX_CN_DATA_FEATURE,
  AUX_FEEDING_FEATURE,
  AUX_FEED_SKU_FEATURE,
  AUX_HATCHERY_FEATURE,
  AUX_RACEWAY_FEATURE,
  AUX_VEHICLE_FEATURE,
  CONTROL_CENTER_FEATURE,
  EVENT_SUMMARY_FEATURE,
  GDST_LOCATIONS_FEATURE,
  GDST_TRADE_ITEMS_FEATURE,
  GDST_TRADING_PARTIES_FEATURE,
  GDST_VESSELS_FEATURE,
  LOT_SHARING_FEATURE,
  LOT_TRACING_FEATURE,
  MASTER_CERTIFICATION_DATA_FEATURE,
  MASTER_LOCATIONS_FEATURE,
  MASTER_PARTIES_FEATURE,
  MASTER_PERSONNEL_FEATURE,
  MASTER_PORT_AREAS_FEATURE,
  MASTER_SKUS_FEATURE,
  MASTER_SPECIES_FEATURE,
  SETTINGS_CONFIG_FEATURE,
  SETTINGS_DESTINATION_SERVICES_FEATURE,
  SETTINGS_SHARING_RULES_FEATURE,
  SETTINGS_USERS_FEATURE,
} from '../customer/customer-features';

type CustomerNavigationItem = FuseNavigationItem & {
  meta?: {
    featureKey?: CustomerFeatureKey;
    roles?: string[];
  };
};

const QUALITY_ONLY = ['ROLE_QUALITY'];
const DATA_ENTRY_ONLY = ['ROLE_DATA_ENTRY'];
const QUALITY_AND_DATA_ENTRY = ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'];
const ADMIN_ONLY: string[] = [];

/** Reports */
const traceabilityReports: CustomerNavigationItem[] = [
  {
    id: 'event-summary',
    title: 'NAVIGATION.EVENT_SUMMARY',
    type: 'basic',
    link: '/traceability/event-summary',
    meta: { featureKey: EVENT_SUMMARY_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'lot-tracing',
    title: 'NAVIGATION.LOT_TRACING',
    type: 'basic',
    link: '/traceability/lot-tracing',
    meta: { featureKey: LOT_TRACING_FEATURE, roles: DATA_ENTRY_ONLY },
  },
  {
    id: 'lot-sharing',
    title: 'NAVIGATION.LOT_SHARING',
    type: 'basic',
    link: '/traceability/lot-sharing',
    meta: { featureKey: LOT_SHARING_FEATURE, roles: QUALITY_ONLY },
  },
];

/** Aquaculture CTEs */
const criticalTrackingEvents: CustomerNavigationItem[] = [
  {
    id: 'hatching',
    title: 'NAVIGATION.HATCHING',
    type: 'basic',
    link: '/ctes/hatching',
    meta: { featureKey: AQUA_HATCHING_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'feed-mill',
    title: 'NAVIGATION.FEED_MILL',
    type: 'basic',
    link: '/ctes/feed-mill',
    meta: { featureKey: AQUA_FEED_MILL_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'feeding',
    title: 'NAVIGATION.FEEDING',
    type: 'basic',
    link: '/ctes/feeding',
    meta: { featureKey: AQUA_FEEDING_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'harvest',
    title: 'NAVIGATION.HARVEST',
    type: 'basic',
    link: '/ctes/harvest',
    meta: { featureKey: AQUA_HARVEST_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'transfer',
    title: 'NAVIGATION.TRANSFER',
    type: 'basic',
    link: '/ctes/transfer',
    meta: { featureKey: AQUA_TRANSFER_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'receipt',
    title: 'NAVIGATION.RECEIVING',
    type: 'basic',
    link: '/ctes/receipt',
    meta: { featureKey: AQUA_RECEIPT_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'processing',
    title: 'NAVIGATION.PROCESSING',
    type: 'basic',
    link: '/ctes/processing',
    meta: { featureKey: AQUA_PROCESSING_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'cold-storage',
    title: 'NAVIGATION.COLD_STORAGE',
    type: 'basic',
    link: '/ctes/cold-storage',
    meta: { featureKey: AQUA_COLD_STORAGE_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'aggregation',
    title: 'NAVIGATION.AGGREGATION',
    type: 'basic',
    link: '/ctes/aggregation',
    meta: { featureKey: AQUA_AGGREGATION_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'disaggregation',
    title: 'NAVIGATION.DISAGGREGATION',
    type: 'basic',
    link: '/ctes/disaggregation',
    meta: { featureKey: AQUA_DISAGGREGATION_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  {
    id: 'shipping',
    title: 'NAVIGATION.SHIPPING',
    type: 'basic',
    link: '/ctes/shipping',
    meta: { featureKey: AQUA_SHIPPING_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
];

const auxiliaryData: CustomerNavigationItem[] = [
  {
    id: 'species',
    title: 'NAVIGATION.SPECIES',
    type: 'basic',
    link: '/master/species',
    meta: { featureKey: MASTER_SPECIES_FEATURE, roles: ADMIN_ONLY },
  },
  // {
  //   id: 'hatchery',
  //   title: 'Hatchery',
  //   type: 'basic',
  //   link: '/aux/hatchery',
  //   meta: { featureKey: AUX_HATCHERY_FEATURE, roles: ADMIN_ONLY },
  // },
  {
    id: 'feed-sku',
    title: 'NAVIGATION.FEED_LOTS',
    type: 'basic',
    link: '/aux/feed-sku',
    meta: { featureKey: AUX_FEED_SKU_FEATURE, roles: ADMIN_ONLY },
  },
  {
    id: 'feeding',
    title: 'NAVIGATION.FEEDING_SUMMARY',
    type: 'basic',
    link: '/aux/feeding',
    meta: { featureKey: AUX_FEEDING_FEATURE, roles: ADMIN_ONLY },
  },
  {
    id: 'raceway',
    title: 'NAVIGATION.RACEWAYS',
    type: 'basic',
    link: '/aux/raceway',
    meta: { featureKey: AUX_RACEWAY_FEATURE, roles: ADMIN_ONLY },
  },
  {
    id: 'cage-details',
    title: 'NAVIGATION.CAGE_DETAILS',
    type: 'basic',
    link: '/aux/cage-details',
    meta: { featureKey: AUX_CAGE_DETAILS_FEATURE, roles: ADMIN_ONLY },
  },
  {
    id: 'vehicle',
    title: 'NAVIGATION.VEHICLES',
    type: 'basic',
    link: '/aux/vehicle',
    meta: { featureKey: AUX_VEHICLE_FEATURE, roles: ADMIN_ONLY },
  },
  {
    id: 'cn-data',
    title: 'NAVIGATION.CN_DATA',
    type: 'basic',
    link: '/aux/cn-data',
    meta: { featureKey: AUX_CN_DATA_FEATURE, roles: ADMIN_ONLY },
  },
];

const masterData: CustomerNavigationItem[] = [
  {
    id: 'trading-parties',
    title: 'NAVIGATION.TRADING_PARTIES',
    type: 'basic',
    link: '/gdst-tools/master-data/trading-parties',
    meta: { featureKey: GDST_TRADING_PARTIES_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'locations',
    title: 'NAVIGATION.LOCATIONS',
    type: 'basic',
    link: '/gdst-tools/master-data/locations',
    meta: { featureKey: GDST_LOCATIONS_FEATURE, roles: QUALITY_ONLY },
  },
  // {
  //   id: 'vessels',
  //   title: 'Vessels',
  //   type: 'basic',
  //   link: '/gdst-tools/master-data/vessels',
  //   meta: { featureKey: GDST_VESSELS_FEATURE, roles: QUALITY_ONLY },
  // },
  {
    id: 'trade-items',
    title: 'NAVIGATION.TRADE_ITEMS',
    type: 'basic',
    link: '/gdst-tools/master-data/trade-items',
    meta: { featureKey: GDST_TRADE_ITEMS_FEATURE, roles: QUALITY_ONLY },
  },
  // {
  //   id: 'parties',
  //   title: 'Parties',
  //   type: 'basic',
  //   link: '/master/parties',
  //   meta: { featureKey: MASTER_PARTIES_FEATURE, roles: ADMIN_ONLY },
  // },
  // {
  //   id: 'locations',
  //   title: 'Location Data',
  //   type: 'basic',
  //   link: '/master/locations',
  //   meta: { featureKey: MASTER_LOCATIONS_FEATURE, roles: ADMIN_ONLY },
  // },
  // {
  //   id: 'port-areas',
  //   title: 'Port Areas',
  //   type: 'basic',
  //   link: '/master/port-areas',
  //   meta: { featureKey: MASTER_PORT_AREAS_FEATURE, roles: ADMIN_ONLY },
  // },
  {
    id: 'personnel',
    title: 'NAVIGATION.PERSONNEL',
    type: 'basic',
    link: '/master/personnel',
    meta: { featureKey: MASTER_PERSONNEL_FEATURE, roles: ADMIN_ONLY },
  },
  // {
  //   id: 'skus',
  //   title: 'Product SKUs',
  //   type: 'basic',
  //   link: '/master/skus',
  //   meta: { featureKey: MASTER_SKUS_FEATURE, roles: ADMIN_ONLY },
  // },
  {
    id: 'certification-data',
    title: 'NAVIGATION.CERTIFICATION_DATA',
    type: 'basic',
    link: '/master/certification-data',
    meta: { featureKey: MASTER_CERTIFICATION_DATA_FEATURE, roles: QUALITY_ONLY },
  },
];

const settingsData: CustomerNavigationItem[] = [
  {
    id: 'users',
    title: 'NAVIGATION.USERS',
    type: 'basic',
    link: '/settings/users',
    meta: { featureKey: SETTINGS_USERS_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'sharing-rules',
    title: 'NAVIGATION.SHARING_RULES',
    type: 'basic',
    link: '/settings/sharing-rules',
    meta: { featureKey: SETTINGS_SHARING_RULES_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'destination-services',
    title: 'NAVIGATION.DESTINATION_SERVICES',
    type: 'basic',
    link: '/settings/destination-services',
    meta: { featureKey: SETTINGS_DESTINATION_SERVICES_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'config',
    title: 'NAVIGATION.CONFIGURATION',
    type: 'basic',
    link: '/settings/config',
    meta: { featureKey: SETTINGS_CONFIG_FEATURE, roles: QUALITY_ONLY },
  },
];

const gdstMasterData: CustomerNavigationItem[] = [
  {
    id: 'trading-parties',
    title: 'Trading Parties',
    type: 'basic',
    link: '/gdst-tools/master-data/trading-parties',
    meta: { featureKey: GDST_TRADING_PARTIES_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'locations',
    title: 'Locations',
    type: 'basic',
    link: '/gdst-tools/master-data/locations',
    meta: { featureKey: GDST_LOCATIONS_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'vessels',
    title: 'Vessels',
    type: 'basic',
    link: '/gdst-tools/master-data/vessels',
    meta: { featureKey: GDST_VESSELS_FEATURE, roles: QUALITY_ONLY },
  },
  {
    id: 'trade-items',
    title: 'Trade Items',
    type: 'basic',
    link: '/gdst-tools/master-data/trade-items',
    meta: { featureKey: GDST_TRADE_ITEMS_FEATURE, roles: QUALITY_ONLY },
  },
];

export const defaultNavigation: CustomerNavigationItem[] = [
  {
    id: 'cte-control-center',
    title: 'NAVIGATION.CONTROL_CENTER',
    type: 'basic',
    icon: 'heroicons_outline:building-office',
    link: '/dashboards/cte-control-center',
    meta: { featureKey: CONTROL_CENTER_FEATURE, roles: QUALITY_AND_DATA_ENTRY },
  },
  { id: 'divider-1', type: 'divider' },
  {
    id: 'traceability',
    title: 'NAVIGATION.TRACEABILITY',
    type: 'collapsable',
    icon: 'heroicons_outline:document-chart-bar',
    children: traceabilityReports,
  },
  {
    id: 'cte',
    title: 'NAVIGATION.CTE',
    type: 'collapsable',
    icon: 'heroicons_outline:clipboard-document-list',
    children: criticalTrackingEvents,
  },
  { id: 'divider-extra-1', type: 'divider' },
  {
    id: 'aux',
    title: 'NAVIGATION.AUXILIARY_DATA',
    type: 'collapsable',
    icon: 'heroicons_outline:circle-stack',
    children: auxiliaryData,
  },
  {
    id: 'master',
    title: 'NAVIGATION.MASTER_DATA',
    type: 'collapsable',
    icon: 'heroicons_outline:queue-list',
    children: masterData,
  },
  // {
  //   id: 'gdst-master-data',
  //   title: 'GDST Master Data',
  //   type: 'collapsable',
  //   icon: 'heroicons_outline:server-stack',
  //   link: '/gdst-tools/master-data',
  //   children: gdstMasterData,
  // },
  {
    id: 'settings',
    title: 'NAVIGATION.SETTINGS',
    type: 'collapsable',
    icon: 'heroicons_outline:cog',
    children: settingsData,
  },
];

export const compactNavigation: CustomerNavigationItem[] = defaultNavigation;
export const futuristicNavigation: CustomerNavigationItem[] = defaultNavigation;
export const horizontalNavigation: CustomerNavigationItem[] = defaultNavigation;
